import { jsxs as C, Fragment as u, jsx as r } from "react/jsx-runtime";
import { useState as x } from "react";
import S from "next/image";
import k from "@mui/material/Menu";
import v from "@mui/material/MenuItem";
import I from "@mui/material/Typography";
import { makeStyles as w } from "tss-react/mui";
import P from "@lumirental/lumi-web-shared/lib/utils/getCountryCodePrefix";
import $ from "./CountryCodeSelect.style.js";
const M = w()($), N = ({
  countryList: n,
  countryCodeInfo: i,
  isRtl: m,
  setSelectedCountry: c,
  hasMobile: d
}) => {
  const [s, l] = x(null), { classes: o } = M(), p = (e) => {
    d || l(e.currentTarget);
  }, a = () => {
    l(null);
  }, h = (e) => {
    c(e), a();
  };
  return /* @__PURE__ */ C(u, { children: [
    /* @__PURE__ */ r(I, { className: o.adornmentText, onClick: p, children: i }),
    /* @__PURE__ */ r("div", { className: o.arrowIcon, children: /* @__PURE__ */ r(
      S,
      {
        src: "/images/svg/expand-arrow-icon.svg",
        alt: "Arrow Icon",
        width: 16,
        height: 16
      }
    ) }),
    /* @__PURE__ */ r(
      k,
      {
        id: "simple-menu",
        anchorEl: s,
        keepMounted: !0,
        open: !!s,
        onClose: a,
        anchorOrigin: {
          vertical: "center",
          horizontal: "left"
        },
        transformOrigin: {
          vertical: "top",
          horizontal: "left"
        },
        classes: {
          paper: o.menuPaper,
          list: o.menuList
        },
        children: n && n.map((e) => {
          const f = (e == null ? void 0 : e.name) ?? "", t = (e == null ? void 0 : e.code) ?? 0, g = `${P(`${t}`, m)} ${f}`;
          return /* @__PURE__ */ r(
            v,
            {
              className: o.menuItem,
              onClick: () => h(t),
              children: g
            },
            t
          );
        })
      }
    )
  ] });
}, q = N;
export {
  q as default
};
